import axios from 'axios';

import { AddressDto } from '@tallo/property';

import { InvestorDto } from '../dtos/investor.dto';
import { UpdateInvestorPreferencesDto } from '../dtos/update-investor-preferences.dto';

class InvestorService {
  async getInvestor(): Promise<InvestorDto> {
    const response = await axios.get('investor/me');
    return response.data as InvestorDto;
  }

  async updateAddress(address: AddressDto): Promise<InvestorDto> {
    const response = await axios.put('investor/address', address);
    return response.data as InvestorDto;
  }

  async updatePreferences(dto: UpdateInvestorPreferencesDto): Promise<InvestorDto> {
    const response = await axios.patch('investor/preferences', dto);
    return response.data as InvestorDto;
  }
}

export default new InvestorService();
